import https from '@/request/index'
// 获取当前时间时间戳（到秒 10位）
export const GetDataTimeNow = (params) => {
  return https.get('/api/Activity/GetDataTimeNow', params)
}
// 获取活动信息
export const GetActivityInfo = (params) => {
  return https.get('/api/Activity/GetActivityInfo', params)
}
// 通过商品Ids获取商品信息
export const GetProductListByIds = (params) => {
  return https.post('/api/Product/GetProductListByIds', params)
}
// 分销佣金排行榜【通过时间查询】
export const GetUserCommissionRankListByTime = (params) => {
  return https.post('/api/UserCommisson/GetUserCommissionRankListByTime', params)
}
// 分销佣金发奖记录
export const GetActivityPrizeRecordEntities = (params) => {
  return https.post('/api/Activity/GetActivityPrizeRecordEntities', params)
}
// 获取是否参与活动
export const GetIsJoinActivity = (params) => {
  return https.post('/api/Activity/GetIsJoinActivity', params)
}
// 查询用户佣金 / 订单信息
export const GetUserActivityInfo = (params) => {
  return https.post('/api/Activity/GetUserActivityInfo', params)
}
// 查看发奖奖励信息
export const GetActPrizeRecordInfo = (params) => {
  return https.post('/api/Activity/GetActPrizeRecordInfo', params)
}
// 活动报名
export const JoinActivity = (params) => {
  return https.post('/api/Activity/JoinActivity', params)
}
// 创建战队
export const CreateActivityGroup = (params) => {
  return https.post('/api/Activity/CreateActivityGroup', params)
}
// 加入战队
export const JoinActivityGroup = (params) => {
  return https.post('/api/Activity/JoinActivityGroup', params)
}
// 获取团队信息
export const GetGroupInfo = (params) => {
  return https.post('/api/Activity/GetGroupInfo', params)
}
// 根据活动Id获取组队Id
export const GetActivityUser = (params) => {
  return https.post('/api/Activity/GetActivityUser', params)
}
// 团队排行列表信息
export const GetGroupOrderNumRankList = (params) => {
  return https.post('/api/Activity/GetGroupOrderNumRankList', params)
}